
import { ApiTokens } from "./types";

export const getDefaultTokens = (): ApiTokens => ({
  openai: '',
  gemini: '',
  elevenlabs: '',
  prompts_per_combination: 5,
  openai_verified: false,
  gemini_verified: false,
  elevenlabs_verified: false,
  openai_verified_at: undefined,
  gemini_verified_at: undefined,
  dataforseo_login: '',
  dataforseo_password: '',
  dataforseo_verified: false,
  dataforseo_verified_at: undefined,
  openai_model: 'gpt-4o-mini',
  gemini_model: 'gemini-2.5-flash-lite',
  firecrawl: '',
  firecrawl_verified: false,
  firecrawl_verified_at: undefined,
  perplexity: '',
  perplexity_verified: false,
  perplexity_verified_at: undefined,
  perplexity_model: 'sonar',
  apify: '',
  apify_verified: false,
  apify_verified_at: undefined,
  youtube_api_key: '',
  youtube_verified: false,
  youtube_verified_at: undefined,
  claude: '',
  claude_verified: false,
  claude_verified_at: undefined,
  claude_model: 'claude-3-5-haiku-20241022',
  hubspot: '',
  hubspot_verified: false,
  hubspot_verified_at: undefined,
  fal_ai: '',
  fal_ai_verified: false,
  fal_ai_verified_at: undefined,
  hailuoai: '',
  hailuoai_group_id: '',
  hailuoai_verified: false,
  hailuoai_verified_at: undefined,
  elevenlabs_verified_at: undefined,
  lumalabs: '',
  lumalabs_verified: false,
  lumalabs_verified_at: undefined,
  lumalabs_model: 'ray-flash-2',
  reddit_client_id: '',
  reddit_client_secret: '',
  reddit_user_agent: '',
  reddit_verified: false,
  reddit_verified_at: undefined,
  byteplus: '',
  byteplus_verified: false,
  byteplus_verified_at: undefined,
  byteplus_model: 'seedreal-4.0',
  wordpress_url: '',
  wordpress_username: '',
  wordpress_password: '',
  wordpress_verified: false,
  wordpress_verified_at: undefined,
  apiflash: '',
  apiflash_verified: false,
  apiflash_verified_at: undefined,
  heygen: '',
  heygen_verified: false,
  heygen_verified_at: undefined,
  youtube_access_token: '',
  youtube_refresh_token: '',
  youtube_token_expires_at: '',
  google_calendar_access_token: '',
  google_calendar_refresh_token: '',
  google_calendar_token_expires_at: '',
  google_calendar_email: '',
  google_calendar_client_id: '',
  google_calendar_client_secret: '',
  cartesia: '',
  cartesia_verified: false,
  cartesia_verified_at: undefined,
  cartesia_model: 'sonic-english',
  gamma: '',
  gamma_verified: false,
  gamma_verified_at: undefined,
  pagespeed: '',
  pagespeed_verified: false,
  pagespeed_verified_at: undefined,
  ghl_api_key: '',
  ghl_location_id: '',
  ghl_verified: false,
  ghl_verified_at: undefined,
  slack_bot_token: '',
  slack_default_channel: '',
  slack_verified: false,
  slack_verified_at: undefined,
  google_sheets_service_account_json: '',
  google_sheets_default_spreadsheet_id: '',
  google_sheets_access_token: '',
  google_sheets_refresh_token: '',
  google_sheets_token_expires_at: '',
  google_sheets_email: '',
  xero_client_id: '',
  xero_client_secret: '',
  xero_verified: false,
  xero_verified_at: undefined,
  domainr: '',
  domainr_verified: false,
  domainr_verified_at: undefined,
  vimeo_access_token: '',
  vimeo_verified: false,
  vimeo_verified_at: undefined,
  youtube_client_id: '',
  youtube_client_secret: '',
});

export const hasValidTokens = (tokens: ApiTokens): boolean => {
  return !!(tokens.openai || tokens.gemini || tokens.dataforseo_login || tokens.firecrawl || tokens.perplexity || tokens.apify || tokens.youtube_api_key || tokens.claude || tokens.hubspot || tokens.fal_ai || tokens.hailuoai || tokens.lumalabs || tokens.reddit_client_id || tokens.byteplus || tokens.wordpress_url || tokens.heygen || tokens.cartesia || tokens.gamma || tokens.pagespeed);
};

